module.exports = __webpack_public_path__ + "img/absorbente11.7e19f8bd.jpg";